<template>
    <div> 
        <loader-component v-if="showLoader"></loader-component>
        <div v-else>
            <!-- responsive-header -->

            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar-component></navbar-component>

                </header>
                <!-- header -->
                <!----------------------------------------------------------------------------------------->
                <!-- main -->
                <main class="content-main default">
                    <div style="background-color:#fff" class="container">
                        <div class="content-main no-padding-right no-padding-left col-md-12 col-sm-12 col-xs-12">
                            <div class="row">
                                <div class="page-title div-img-header">
                                    <div class="container">
                                        <div class="row">
                                            <div class="div-title-main col col-xs-12">
                                                <h2>تماس با ما</h2>
                                                <ol class="breadcrumb">
                                                    <li><a href="/" title="صفحه اصلی">صفحه اصلی</a></li>
                                                    <li>تماس با ما</li>
                                                </ol>
                                            </div>
                                        </div> <!-- end row -->
                                    </div>
                                </div>
                                <div class="content">
                                    <div class="div-content">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                                                    <img style="position:absolute;top:43%;left:43%;z-index:100" src="/assets/img/loader/loader.svg" />
                                                </div>
                                                <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                                    <li v-for="error in errors.all()">{{ error }}</li>
                                                </ul>
                                                <form @submit.prevent="sendMessage" class="form-account">
                                                    <div class="form-account-title">نام نام خانوادگی</div>
                                                    <div class="form-account-row">
                                                        <label class="input-label">
                                                            <i class="now-ui-icons users_single-02"></i>
                                                        </label>
                                                        <input type="text" v-validate="{required: true , max:80  }" data-vv-as="نام نام خانوادگی" v-model="MessageInfo.FullName" placeholder="نام نام خانوادگی خود را وارد نمایید" class="input-field text-right" aria-required="false" aria-invalid="false">
                                                    </div>
                                                    <div class="form-account-title">شماره موبایل</div>
                                                    <div class="form-account-row">
                                                        <label class="input-label">
                                                            <i class="now-ui-icons tech_mobile"></i>
                                                        </label>
                                                        <input type="text" v-validate="{ required: true, regex:/^0\d{10}$/ }" data-vv-as="شماره موبایل" v-model="MessageInfo.MobNo" placeholder="شماره موبایل خود را وارد نمایید" class="input-field text-right" aria-required="false" aria-invalid="false">
                                                    </div>
                                                    <div class="form-account-title">ایمیل</div>
                                                    <div class="form-account-row">
                                                        <label class="input-label">
                                                            <i class="now-ui-icons ui-1_email-85"></i>
                                                        </label>
                                                        <input type="text" v-validate="{required: true ,email:true }" data-vv-as="ایمیل" v-model="MessageInfo.Email" placeholder="ایمیل خود را وارد نمایید" class="input-field text-right" aria-required="false" aria-invalid="false">
                                                    </div>
                                                    <div class="form-account-title">متن پیام</div>
                                                    <div class="form-account-row">
                                                        <textarea rows="3" v-validate="{required: true , max:1000  }" data-vv-as="متن پیام" v-model="MessageInfo.Comment" type="text" placeholder="متن پیام خود را وارد نمایید" class="input-field text-right input-textarea" aria-required="false" aria-invalid="false"></textarea>
                                                    </div>
                                                    <div class="btn-div">
                                                        <button type="submit" class="btn btn-info"> ارسال پیام </button>
                                                    </div>
                                                </form>

                                            </div>

                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flex-addres">
                                                <div class="address-phone">
                                                    <div class="spn-address"><span class="ti-address"><span class="fa fa-map"></span> آدرس</span> : <span class="tx-address">{{baseInfo.Address}} </span></div>
                                                    <div class="spn-phone"><span class="ti-phone"><span class="fa fa-phone"></span> شماره تماس </span> : <span class="tx-phone"><a :href="'tel:' + baseInfo.TellNo ">{{ baseInfo.TellNo }}</a></span></div>
                                                </div>
                                                <!--<div class="iframe-div">
                                                    <gmap-map :center="{ lat: baseInfo.Lat, lng: baseInfo.Lng }"
                                                              :zoom="15"
                                                              style="width:600px;height: 450px;">
                                                        <gmap-marker :key="index"
                                                                     :position="{ lat: baseInfo.Lat, lng: baseInfo.Lng }"></gmap-marker>
                                                    </gmap-map>
                                                </div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <!-- main -->
                <!------------------------------------------------------------------------------------------>
                <footer-component></footer-component>
                <footer-fixnav-component></footer-fixnav-component>
            </div>
        </div>

    </div>
</template>

<script>
    import { initialSite } from "../../module/initialSite";
    import { httpPromise } from "../../module/httpUtility";
    import specialBrands from '../homeComponents/specialBrands.vue';
    export default {
        data() {
            return {
                MessageInfo: {},
                isShowSppiner: false,
                showLoader: false,
            }
        },
        beforeMount: function () {
            this.scrollTop();
            createPageTitle('تماس با ما');
            initialSite(this);
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            sendMessage() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/ContactUs/AddMessage', 'post', JSON.stringify(this.MessageInfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                this.MessageInfo = {};
                                this.isShowSppiner = false;
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.MessageInfo = {};
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            scrollTop() {
                $(function () {
                    $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo');
                });
            }
        },
        components: {
            'special-brands': specialBrands
        }
    }
</script>

<style type="text/css">
    .flex-addres .spn-address .ti-address, .flex-addres .spn-phone .ti-phone {
        font-weight: bold;
        font-size: 16px;
    }
    .flex-addres .spn-address .tx-address, .flex-addres .spn-phone .tx-phone {
        font-size: 15px;
    }
    .flex-addres .spn-address {
        margin-bottom:25px;
    }
    .flex-addres .address-phone {
        border:1px solid #ddd;
        border-radius:15px;
        padding:25px;
        transition:all .3s;

    }
        .flex-addres .address-phone:hover {
            border: 1px solid #a8f18a;
            transition: all .3s;
        }

        .flex-addres {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    .iframe-div {
        height: 415px;
        margin-bottom: 30px;
        margin-top: 30px;
    }

        .iframe-div iframe {
            width: 100%;
            height: 100%;
        }
    /*title image*/
    .div-title-main {
        padding-right: 150px;
    }

    .div-img-header {
        background: url("/assets/img/header/page-title.jpg") center center/cover no-repeat local;
        height: 260px;
        position: relative;
        width: 100%;
    }

    .page-title .breadcrumb {
        text-align: center;
    }

    .page-title .breadcrumb {
        background-color: transparent;
        padding: 0;
    }

    .page-title ol {
        color: #fff;
    }

    .page-title h2 {
        font-size: 48px;
        font-size: 3.2rem;
        font-weight: 800;
        margin: 1em 0 0.23em;
    }

    .page-title h2 {
        color: #fff;
    }

    .page-title .breadcrumb li a {
        color: #fff;
    }

    .page-title .breadcrumb li {
        font-size: 18px;
        font-size: 1.2rem;
        color: #fdc900;
        margin-left: 5px;
    }

    .page-title::before {
        content: "";
        background-color: rgba(0, 0, 0, 0.3);
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }

    .page-title .breadcrumb > li + li::before {
        font-family: "FontAwesome";
        content: "\f104";
        color: #fff;
        margin-left: 5px;
    }

    .page-title .breadcrumb li a:hover {
        color: #fdc900;
    }
    /*title image*/

    .address-text p {
        color: #777;
        font-size: 14px;
        padding-right: 7px;
    }

    .address-title i {
        font-size: 20px;
        color: cadetblue;
        vertical-align: baseline;
    }

    .address-title span {
        font-size: 18px;
        font-weight: bold;
        color: #555;
    }

    .btn-info {
        background-color: #2CA8FF;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 17px;
        padding: 8px 35px;
    }

    .btn-div {
        text-align: center;
        margin-bottom: 30px;
    }
    /*محتویات Css  قسمت مدیریت صفحات استاتیک*/
    .input-textarea {
        padding: 11px 15px 11px 11px;
    }

    .content-main .content {
        width: 100%;
        margin: 20px 12%;
        padding: 20px;
    }

        .content-main .content .title {
            font-size: 20px;
            padding-right: 20px;
            padding-top: 20px;
        }

        .content-main .content .div-content p {
            text-align: justify;
            line-height: 2;
            font-size: 15px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .input-field {
            padding: 11px 45px 11px 11px;
        }

        nav .header-responsive {
            height: 152px;
        }

        .div-title-main {
            padding-right: 20px;
        }

        .address-title span {
            font-size: 16px;
        }

        .content-main .content {
            margin: 40px 0%;
        }

            .content-main .content .title {
                font-size: 17px;
            }

            .content-main .content .div-content p {
                text-align: justify;
                line-height: 2;
                font-size: 12px;
            }
    }
    /*محتویات Css  قسمت مدیریت صفحات استاتیک*/
</style>